export default __webpack_public_path__ + "static/h-p-avatar-2-150x150-da32e9370b92d401848a289a7f30c75d.png";